/* ---- Splide library (MIT) + splide component ---- */
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var s = e[i];
    ((s.enumerable = s.enumerable || !1),
      (s.configurable = !0),
      "value" in s && (s.writable = !0),
      Object.defineProperty(t, s.key, s));
  }
}
function _createClass(t, e, i) {
  return (
    e && _defineProperties(t.prototype, e),
    i && _defineProperties(t, i),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    t
  );
}
((function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t =
            "undefined" != typeof globalThis ? globalThis : t || self).Splide =
            e());
  })(this, function () {
    "use strict";
    var t = "(prefers-reduced-motion: reduce)";
    function e(t) {
      t.length = 0;
    }
    function i(t, e, i) {
      return Array.prototype.slice.call(t, e, i);
    }
    function s(t) {
      return t.bind.apply(t, [null].concat(i(arguments, 1)));
    }
    var n = setTimeout,
      r = function t() {};
    function o(t) {
      return requestAnimationFrame(t);
    }
    function a(t, e) {
      return typeof e === t;
    }
    function l(t) {
      return !p(t) && a("object", t);
    }
    var d = Array.isArray,
      c = s(a, "function"),
      h = s(a, "string"),
      u = s(a, "undefined");
    function p(t) {
      return null === t;
    }
    function m(t) {
      try {
        return t instanceof (t.ownerDocument.defaultView || window).HTMLElement;
      } catch (e) {
        return !1;
      }
    }
    function f(t) {
      return d(t) ? t : [t];
    }
    function y(t, e) {
      f(t).forEach(e);
    }
    function g(t, e) {
      return t.indexOf(e) > -1;
    }
    function v(t, e) {
      return (t.push.apply(t, f(e)), t);
    }
    function b(t, e, i) {
      t &&
        y(e, function (e) {
          e && t.classList[i ? "add" : "remove"](e);
        });
    }
    function $(t, e) {
      b(t, h(e) ? e.split(" ") : e, !0);
    }
    function S(t, e) {
      y(e, t.appendChild.bind(t));
    }
    function E(t, e) {
      y(t, function (t) {
        var i = (e || t).parentNode;
        i && i.insertBefore(t, e);
      });
    }
    function k(t, e) {
      return m(t) && (t.msMatchesSelector || t.matches).call(t, e);
    }
    function C(t, e) {
      var s = t ? i(t.children) : [];
      return e
        ? s.filter(function (t) {
            return k(t, e);
          })
        : s;
    }
    function x(t, e) {
      return e ? C(t, e)[0] : t.firstElementChild;
    }
    var L = Object.keys;
    function _(t, e, i) {
      return (
        t &&
          (i ? L(t).reverse() : L(t)).forEach(function (i) {
            "__proto__" !== i && e(t[i], i);
          }),
        t
      );
    }
    function w(t) {
      return (
        i(arguments, 1).forEach(function (e) {
          _(e, function (i, s) {
            t[s] = e[s];
          });
        }),
        t
      );
    }
    function T(t) {
      return (
        i(arguments, 1).forEach(function (e) {
          _(e, function (e, i) {
            d(e)
              ? (t[i] = e.slice())
              : l(e)
                ? (t[i] = T({}, l(t[i]) ? t[i] : {}, e))
                : (t[i] = e);
          });
        }),
        t
      );
    }
    function A(t, e) {
      y(e || L(t), function (e) {
        delete t[e];
      });
    }
    function M(t, e) {
      y(t, function (t) {
        y(e, function (e) {
          t && t.removeAttribute(e);
        });
      });
    }
    function B(t, e, i) {
      l(e)
        ? _(e, function (e, i) {
            B(t, i, e);
          })
        : y(t, function (t) {
            p(i) || "" === i ? M(t, e) : t.setAttribute(e, String(i));
          });
    }
    function P(t, e, i) {
      var s = document.createElement(t);
      return (e && (h(e) ? $(s, e) : B(s, e)), i && S(i, s), s);
    }
    function I(t, e, i) {
      if (u(i)) return getComputedStyle(t)[e];
      p(i) || (t.style[e] = "" + i);
    }
    function q(t, e) {
      I(t, "display", e);
    }
    function D(t) {
      (t.setActive && t.setActive()) || t.focus({ preventScroll: !0 });
    }
    function H(t, e) {
      return t.getAttribute(e);
    }
    function O(t, e) {
      return t && t.classList.contains(e);
    }
    function R(t) {
      return t.getBoundingClientRect();
    }
    function z(t) {
      y(t, function (t) {
        t && t.parentNode && t.parentNode.removeChild(t);
      });
    }
    function N(t) {
      return x(new DOMParser().parseFromString(t, "text/html").body);
    }
    function F(t, e) {
      (t.preventDefault(),
        e && (t.stopPropagation(), t.stopImmediatePropagation()));
    }
    function V(t, e) {
      return t && t.querySelector(e);
    }
    function W(t, e) {
      return e ? i(t.querySelectorAll(e)) : [];
    }
    function U(t, e) {
      b(t, e, !1);
    }
    function X(t) {
      return t.timeStamp;
    }
    function G(t) {
      return h(t) ? t : t ? t + "px" : "";
    }
    var j = "splide",
      Y = "data-" + j;
    function K(t, e) {
      if (!t) throw Error("[" + j + "] " + (e || ""));
    }
    var Q = Math.min,
      J = Math.max,
      Z = Math.floor,
      tt = Math.ceil,
      te = Math.abs;
    function ti(t, e, i) {
      return te(t - e) < i;
    }
    function ts(t, e, i, s) {
      var n = Q(e, i),
        r = J(e, i);
      return s ? n < t && t < r : n <= t && t <= r;
    }
    function tn(t, e, i) {
      var s = Q(e, i),
        n = J(e, i);
      return Q(J(s, t), n);
    }
    function tr(t) {
      return +(t > 0) - +(t < 0);
    }
    function to(t, e) {
      return (
        y(e, function (e) {
          t = t.replace("%s", "" + e);
        }),
        t
      );
    }
    function ta(t) {
      return t < 10 ? "0" + t : "" + t;
    }
    var tl = {};
    function td() {
      var t = [];
      function i(t, e, i) {
        y(t, function (t) {
          t &&
            y(e, function (e) {
              e.split(" ").forEach(function (e) {
                var s = e.split(".");
                i(t, s[0], s[1]);
              });
            });
        });
      }
      return {
        bind: function e(s, n, r, o) {
          i(s, n, function (e, i, s) {
            var n = "addEventListener" in e,
              a = n
                ? e.removeEventListener.bind(e, i, r, o)
                : e.removeListener.bind(e, r);
            (n ? e.addEventListener(i, r, o) : e.addListener(r),
              t.push([e, i, s, r, a]));
          });
        },
        unbind: function e(s, n, r) {
          i(s, n, function (e, i, s) {
            t = t.filter(function (t) {
              return (
                t[0] !== e ||
                t[1] !== i ||
                t[2] !== s ||
                (!!r && t[3] !== r) ||
                (t[4](), !1)
              );
            });
          });
        },
        dispatch: function t(e, i, s) {
          var n;
          return (
            "function" == typeof CustomEvent
              ? (n = new CustomEvent(i, { bubbles: !0, detail: s }))
              : (n = document.createEvent("CustomEvent")).initCustomEvent(
                  i,
                  !0,
                  !1,
                  s,
                ),
            e.dispatchEvent(n),
            n
          );
        },
        destroy: function i() {
          (t.forEach(function (t) {
            t[4]();
          }),
            e(t));
        },
      };
    }
    var tc = "mounted",
      th = "ready",
      tu = "move",
      tp = "moved",
      tm = "click",
      tf = "refresh",
      ty = "updated",
      tg = "resize",
      tv = "resized",
      tb = "scroll",
      t$ = "scrolled",
      tS = "destroy",
      tE = "navigation:mounted",
      tk = "autoplay:play",
      tC = "autoplay:pause",
      tx = "lazyload:loaded";
    function tL(t) {
      var e = t ? t.event.bus : document.createDocumentFragment(),
        n = td();
      return (
        t && t.event.on(tS, n.destroy),
        w(n, {
          bus: e,
          on: function t(i, s) {
            n.bind(e, f(i).join(" "), function (t) {
              s.apply(s, d(t.detail) ? t.detail : []);
            });
          },
          off: s(n.unbind, e),
          emit: function t(s) {
            n.dispatch(e, s, i(arguments, 1));
          },
        })
      );
    }
    function t_(t, e, i, s) {
      var n,
        r,
        a = Date.now,
        l = 0,
        d = !0,
        c = 0;
      function h() {
        if (!d) {
          if (
            ((l = t ? Q((a() - n) / t, 1) : 1),
            i && i(l),
            l >= 1 && (e(), (n = a()), s && ++c >= s))
          )
            return u();
          r = o(h);
        }
      }
      function u() {
        d = !0;
      }
      function p() {
        (r && cancelAnimationFrame(r), (l = 0), (r = 0), (d = !0));
      }
      function m(e) {
        t = e;
      }
      function f() {
        return d;
      }
      return {
        start: function e(i) {
          (i || p(), (n = a() - (i ? l * t : 0)), (d = !1), (r = o(h)));
        },
        rewind: function t() {
          ((n = a()), (l = 0), i && i(l));
        },
        pause: u,
        cancel: p,
        set: m,
        isPaused: f,
      };
    }
    var t8 = "Arrow",
      tw = t8 + "Left",
      tT = t8 + "Right",
      tA = t8 + "Up",
      tM = t8 + "Down",
      tB = {
        width: ["height"],
        left: ["top", "right"],
        right: ["bottom", "left"],
        x: ["y"],
        X: ["Y"],
        Y: ["X"],
        ArrowLeft: [tA, tT],
        ArrowRight: [tM, tw],
      },
      tP = "role",
      tI = "tabindex",
      tq = "aria-",
      tD = tq + "controls",
      tH = tq + "current",
      tO = tq + "selected",
      tR = tq + "label",
      tz = tq + "labelledby",
      tN = tq + "hidden",
      tF = tq + "orientation",
      tV = tq + "roledescription",
      tW = tq + "live",
      t9 = tq + "busy",
      tU = tq + "atomic",
      t0 = [tP, tI, "disabled", tD, tH, tR, tz, tN, tF, tV],
      t2 = j + "__",
      t3 = j,
      t4 = t2 + "track",
      t1 = t2 + "list",
      tX = t2 + "slide",
      tG = tX + "--clone",
      tj = tX + "__container",
      tY = t2 + "arrows",
      t6 = t2 + "arrow",
      t7 = t6 + "--prev",
      tK = t6 + "--next",
      t5 = t2 + "pagination",
      tQ = t5 + "__page",
      tJ = t2 + "progress__bar",
      tZ = t2 + "toggle",
      et = t2 + "sr",
      ee = "is-active",
      ei = "is-prev",
      es = "is-next",
      en = "is-visible",
      er = "is-loading",
      eo = "is-focus-in",
      ea = "is-overflow",
      el = [ee, en, ei, es, er, eo, ea],
      ed = "touchstart mousedown",
      ec = "touchmove mousemove",
      eh = "touchend touchcancel mouseup click",
      eu = "slide",
      ep = "loop",
      em = "fade",
      ef = Y + "-interval",
      ey = { passive: !1, capture: !0 },
      eg = { Spacebar: " ", Right: tT, Left: tw, Up: tA, Down: tM };
    function ev(t) {
      return eg[(t = h(t) ? t : t.key)] || t;
    }
    var eb = "keydown",
      e$ = Y + "-lazy",
      eS = e$ + "-srcset",
      eE = "[" + e$ + "], [" + eS + "]",
      ek = [" ", "Enter"],
      eC = Object.freeze({
        __proto__: null,
        Media: function e(i, s, n) {
          var r = i.state,
            o = n.breakpoints || {},
            a = n.reducedMotion || {},
            l = td(),
            d = [];
          function c(t) {
            t && l.destroy();
          }
          function h(t, e) {
            var i = matchMedia(e);
            (l.bind(i, "change", u), d.push([t, i]));
          }
          function u() {
            var t = r.is(7),
              e = n.direction,
              s = d.reduce(function (t, e) {
                return T(t, e[1].matches ? e[0] : {});
              }, {});
            (A(n),
              p(s),
              n.destroy
                ? i.destroy("completely" === n.destroy)
                : t
                  ? (c(!0), i.mount())
                  : e !== n.direction && i.refresh());
          }
          function p(t, e, s) {
            (T(n, t),
              e && T(Object.getPrototypeOf(n), t),
              (s || !r.is(1)) && i.emit(ty, n));
          }
          return {
            setup: function e() {
              var i = "min" === n.mediaQuery;
              (L(o)
                .sort(function (t, e) {
                  return i ? +t - +e : +e - +t;
                })
                .forEach(function (t) {
                  h(o[t], "(" + (i ? "min" : "max") + "-width:" + t + "px)");
                }),
                h(a, t),
                u());
            },
            destroy: c,
            reduce: function e(i) {
              matchMedia(t).matches && (i ? T(n, a) : A(n, L(a)));
            },
            set: p,
          };
        },
        Direction: function t(e, i, s) {
          return {
            resolve: function t(e, i, n) {
              var r =
                "rtl" !== (n = n || s.direction) || i
                  ? "ttb" === n
                    ? 0
                    : -1
                  : 1;
              return (
                (tB[e] && tB[e][r]) ||
                e.replace(/width|left|right/i, function (t, e) {
                  var i = tB[t.toLowerCase()][r] || t;
                  return e > 0 ? i.charAt(0).toUpperCase() + i.slice(1) : i;
                })
              );
            },
            orient: function t(e) {
              return e * ("rtl" === s.direction ? 1 : -1);
            },
          };
        },
        Elements: function t(i, s, n) {
          var r,
            o,
            a,
            l = tL(i),
            d = l.on,
            h = l.bind,
            u = i.root,
            p = n.i18n,
            m = {},
            f = [],
            y = [],
            g = [];
          function S() {
            var t, e, i;
            ((r = T("." + t4)),
              (o = x(r, "." + t1)),
              K(r && o, "A track/list element is missing."),
              v(f, C(o, "." + tX + ":not(." + tG + ")")),
              _(
                {
                  arrows: tY,
                  pagination: t5,
                  prev: t7,
                  next: tK,
                  bar: tJ,
                  toggle: tZ,
                },
                function (t, e) {
                  m[e] = T("." + t);
                },
              ),
              w(m, { root: u, track: r, list: o, slides: f }),
              (e = u.id || "" + (t = j) + ta((tl[t] = (tl[t] || 0) + 1))),
              (i = n.role),
              (u.id = e),
              (r.id = r.id || e + "-track"),
              (o.id = o.id || e + "-list"),
              !H(u, tP) && "SECTION" !== u.tagName && i && B(u, tP, i),
              B(u, tV, p.carousel),
              B(o, tP, "presentation"),
              L());
          }
          function E(t) {
            var i = t0.concat("style");
            (e(f), U(u, y), U(r, g), M([r, o], i), M(u, t ? i : ["style", tV]));
          }
          function L() {
            (U(u, y),
              U(r, g),
              (y = A(t3)),
              (g = A(t4)),
              $(u, y),
              $(r, g),
              B(u, tR, n.label),
              B(u, tz, n.labelledby));
          }
          function T(t) {
            var e = V(u, t);
            return e &&
              (function t(e, i) {
                if (c(e.closest)) return e.closest(i);
                for (var s = e; s && 1 === s.nodeType && !k(s, i);)
                  s = s.parentElement;
                return s;
              })(e, "." + t3) === u
              ? e
              : void 0;
          }
          function A(t) {
            return [
              t + "--" + n.type,
              t + "--" + n.direction,
              n.drag && t + "--draggable",
              n.isNavigation && t + "--nav",
              t === t3 && ee,
            ];
          }
          return w(m, {
            setup: S,
            mount: function t() {
              (d(tf, E),
                d(tf, S),
                d(ty, L),
                h(
                  document,
                  ed + " keydown",
                  function (t) {
                    a = "keydown" === t.type;
                  },
                  { capture: !0 },
                ),
                h(u, "focusin", function () {
                  b(u, eo, !!a);
                }));
            },
            destroy: E,
          });
        },
        Slides: function t(i, n, r) {
          var o = tL(i),
            a = o.on,
            l = o.emit,
            d = o.bind,
            u = n.Elements,
            p = u.slides,
            v = u.list,
            C = [];
          function L() {
            p.forEach(function (t, e) {
              w(t, e, -1);
            });
          }
          function _() {
            (A(function (t) {
              t.destroy();
            }),
              e(C));
          }
          function w(t, e, n) {
            var r = (function t(e, i, n, r) {
              var o,
                a = tL(e),
                l = a.on,
                d = a.emit,
                c = a.bind,
                h = e.Components,
                u = e.root,
                p = e.options,
                m = p.isNavigation,
                f = p.updateOnMove,
                y = p.i18n,
                g = p.pagination,
                v = p.slideFocus,
                $ = h.Direction.resolve,
                S = H(r, "style"),
                E = H(r, tR),
                k = n > -1,
                C = x(r, "." + tj);
              function L() {
                var t = e.splides
                  .map(function (t) {
                    var e = t.splide.Components.Slides.getAt(i);
                    return e ? e.slide.id : "";
                  })
                  .join(" ");
                (B(r, tR, to(y.slideX, (k ? n : i) + 1)),
                  B(r, tD, t),
                  B(r, tP, v ? "button" : ""),
                  v && M(r, tV));
              }
              function _() {
                o || w();
              }
              function w() {
                if (!o) {
                  var t,
                    s = e.index;
                  ((t = T()) !== O(r, ee) &&
                    (b(r, ee, t),
                    B(r, tH, (m && t) || ""),
                    d(t ? "active" : "inactive", A)),
                    (function t() {
                      var i = (function t() {
                          if (e.is(em)) return T();
                          var i = R(h.Elements.track),
                            s = R(r),
                            n = $("left", !0),
                            o = $("right", !0);
                          return Z(i[n]) <= tt(s[n]) && Z(s[o]) <= tt(i[o]);
                        })(),
                        s = !i && (!T() || k);
                      if (
                        (e.state.is([4, 5]) || B(r, tN, s || ""),
                        B(W(r, p.focusableNodes || ""), tI, s ? -1 : ""),
                        v && B(r, tI, s ? -1 : 0),
                        i !== O(r, en) &&
                          (b(r, en, i), d(i ? "visible" : "hidden", A)),
                        !i && document.activeElement === r)
                      ) {
                        var n = h.Slides.getAt(e.index);
                        n && D(n.slide);
                      }
                    })(),
                    b(r, ei, i === s - 1),
                    b(r, es, i === s + 1));
                }
              }
              function T() {
                var t = e.index;
                return t === i || (p.cloneStatus && t === n);
              }
              var A = {
                index: i,
                slideIndex: n,
                slide: r,
                container: C,
                isClone: k,
                mount: function t() {
                  (k ||
                    ((r.id = u.id + "-slide" + ta(i + 1)),
                    B(r, tP, g ? "tabpanel" : "group"),
                    B(r, tV, y.slide),
                    B(r, tR, E || to(y.slideLabel, [i + 1, e.length]))),
                    c(r, "click", s(d, tm, A)),
                    c(r, "keydown", s(d, "sk", A)),
                    l([tp, "sh", t$], w),
                    l(tE, L),
                    f && l(tu, _));
                },
                destroy: function t() {
                  ((o = !0),
                    a.destroy(),
                    U(r, el),
                    M(r, t0),
                    B(r, "style", S),
                    B(r, tR, E || ""));
                },
                update: w,
                style: function t(e, i, s) {
                  I((s && C) || r, e, i);
                },
                isWithin: function t(s, n) {
                  var r = te(s - i);
                  return (
                    !k && (p.rewind || e.is(ep)) && (r = Q(r, e.length - r)),
                    r <= n
                  );
                },
              };
              return A;
            })(i, e, n, t);
            (r.mount(),
              C.push(r),
              C.sort(function (t, e) {
                return t.index - e.index;
              }));
          }
          function T(t) {
            return t
              ? P(function (t) {
                  return !t.isClone;
                })
              : C;
          }
          function A(t, e) {
            T(e).forEach(t);
          }
          function P(t) {
            return C.filter(
              c(t)
                ? t
                : function (e) {
                    return h(t) ? k(e.slide, t) : g(f(t), e.index);
                  },
            );
          }
          return {
            mount: function t() {
              (L(), a(tf, _), a(tf, L));
            },
            destroy: _,
            update: function t() {
              A(function (t) {
                t.update();
              });
            },
            register: w,
            get: T,
            getIn: function t(e) {
              var i = n.Controller,
                s = i.toIndex(e),
                o = i.hasFocus() ? 1 : r.perPage;
              return P(function (t) {
                return ts(t.index, s, s + o - 1);
              });
            },
            getAt: function t(e) {
              return P(e)[0];
            },
            add: function t(e, i) {
              (y(e, function (t) {
                if ((h(t) && (t = N(t)), m(t))) {
                  var e,
                    n,
                    o,
                    a,
                    c = p[i];
                  (c ? E(t, c) : S(v, t),
                    $(t, r.classes.slide),
                    (e = t),
                    (n = s(l, tg)),
                    (a = (o = W(e, "img")).length)
                      ? o.forEach(function (t) {
                          d(t, "load error", function () {
                            --a || n();
                          });
                        })
                      : n());
                }
              }),
                l(tf));
            },
            remove: function t(e) {
              (z(
                P(e).map(function (t) {
                  return t.slide;
                }),
              ),
                l(tf));
            },
            forEach: A,
            filter: P,
            style: function t(e, i, s) {
              A(function (t) {
                t.style(e, i, s);
              });
            },
            getLength: function t(e) {
              return e ? p.length : C.length;
            },
            isEnough: function t() {
              return C.length > r.perPage;
            },
          };
        },
        Layout: function t(e, i, n) {
          var r,
            o,
            a,
            d = tL(e),
            c = d.on,
            h = d.bind,
            u = d.emit,
            p = i.Slides,
            m = i.Direction.resolve,
            f = i.Elements,
            y = f.root,
            g = f.track,
            v = f.list,
            $ = p.getAt,
            S = p.style;
          function E() {
            ((r = "ttb" === n.direction),
              I(y, "maxWidth", G(n.width)),
              I(g, m("paddingLeft"), C(!1)),
              I(g, m("paddingRight"), C(!0)),
              k(!0));
          }
          function k(t) {
            var e,
              i = R(y);
            (t || o.width !== i.width || o.height !== i.height) &&
              (I(
                g,
                "height",
                ((e = ""),
                r &&
                  ((e = x()),
                  K(e, "height or heightRatio is missing."),
                  (e = "calc(" + e + " - " + C(!1) + " - " + C(!0) + ")")),
                e),
              ),
              S(m("marginRight"), G(n.gap)),
              S(
                "width",
                n.autoWidth ? null : G(n.fixedWidth) || (r ? "" : L()),
              ),
              S(
                "height",
                G(n.fixedHeight) || (r ? (n.autoHeight ? null : L()) : x()),
                !0,
              ),
              (o = i),
              u(tv),
              a !== (a = B()) && (b(y, ea, a), u("overflow", a)));
          }
          function C(t) {
            var e = n.padding,
              i = m(t ? "right" : "left");
            return (e && G(e[i] || (l(e) ? 0 : e))) || "0px";
          }
          function x() {
            return G(n.height || R(v).width * n.heightRatio);
          }
          function L() {
            var t = G(n.gap);
            return (
              "calc((100%" +
              (t && " + " + t) +
              ")/" +
              (n.perPage || 1) +
              (t && " - " + t) +
              ")"
            );
          }
          function _() {
            return R(v)[m("width")];
          }
          function w(t, e) {
            var i = $(t || 0);
            return i ? R(i.slide)[m("width")] + (e ? 0 : M()) : 0;
          }
          function T(t, e) {
            var i = $(t);
            if (i) {
              var s = R(i.slide)[m("right")],
                n = R(v)[m("left")];
              return te(s - n) + (e ? 0 : M());
            }
            return 0;
          }
          function A(t) {
            return T(e.length - 1) - T(0) + w(0, t);
          }
          function M() {
            var t = $(0);
            return (t && parseFloat(I(t.slide, m("marginRight")))) || 0;
          }
          function B() {
            return e.is(em) || A(!0) > _();
          }
          return {
            mount: function t() {
              var e, i;
              (E(),
                h(
                  window,
                  "resize load",
                  ((e = s(u, tg)),
                  (i = t_(0, e, null, 1)),
                  function () {
                    i.isPaused() && i.start();
                  }),
                ),
                c([ty, tf], E),
                c(tg, k));
            },
            resize: k,
            listSize: _,
            slideSize: w,
            sliderSize: A,
            totalSize: T,
            getPadding: function t(e) {
              return (
                parseFloat(I(g, m("padding" + (e ? "Right" : "Left")))) || 0
              );
            },
            isOverflow: B,
          };
        },
        Clones: function t(i, s, n) {
          var r,
            o = tL(i),
            a = o.on,
            l = s.Elements,
            d = s.Slides,
            c = s.Direction.resolve,
            h = [];
          function p() {
            (a(tf, m),
              a([ty, tg], y),
              (r = g()) &&
                ((function t(e) {
                  var s = d.get().slice(),
                    r = s.length;
                  if (r) {
                    for (; s.length < e;) v(s, s);
                    v(s.slice(-e), s.slice(0, e)).forEach(function (t, o) {
                      var a,
                        c,
                        u,
                        p = o < e,
                        m =
                          ((a = t.slide),
                          (c = o),
                          (u = a.cloneNode(!0)),
                          $(u, n.classes.clone),
                          (u.id = i.root.id + "-clone" + ta(c + 1)),
                          u);
                      (p ? E(m, s[0].slide) : S(l.list, m),
                        v(h, m),
                        d.register(m, o - e + (p ? 0 : r), t.index));
                    });
                  }
                })(r),
                s.Layout.resize(!0)));
          }
          function m() {
            (f(), p());
          }
          function f() {
            (z(h), e(h), o.destroy());
          }
          function y() {
            var t = g();
            r !== t && (r < t || !t) && o.emit(tf);
          }
          function g() {
            var t = n.clones;
            if (i.is(ep)) {
              if (u(t)) {
                var e = n[c("fixedWidth")] && s.Layout.slideSize(0);
                t =
                  (e && tt(R(l.track)[c("width")] / e)) ||
                  (n[c("autoWidth")] && i.length) ||
                  2 * n.perPage;
              }
            } else t = 0;
            return t;
          }
          return { mount: p, destroy: f };
        },
        Move: function t(e, i, s) {
          var n,
            r = tL(e),
            o = r.on,
            a = r.emit,
            l = e.state.set,
            d = e.state,
            c = i.Layout,
            h = c.slideSize,
            p = c.getPadding,
            m = c.totalSize,
            f = c.listSize,
            y = c.sliderSize,
            g = i.Direction,
            v = g.resolve,
            b = g.orient,
            $ = i.Elements,
            S = $.list,
            E = $.track,
            k = 0;
          function C() {
            return k;
          }
          function x() {
            i.Controller.isBusy() ||
              (i.Scroll.cancel(), L(e.index), i.Slides.update());
          }
          function L(t) {
            _(M(t, !0));
          }
          function _(t, n) {
            if (!e.is(em)) {
              s.paddingCalc &&
                "slide" === s.type &&
                !d.is(6) &&
                (k =
                  t >= -1 * s.padding.right
                    ? 0
                    : y() + t - s.padding.right <= h()
                      ? s.padding.right
                      : s.padding.right / 2);
              var r = n
                ? t
                : (function t(s) {
                    if (e.is(ep)) {
                      var n = A(s),
                        r = n > i.Controller.getEnd();
                      (n < 0 || r) && (s = w(s, r));
                    }
                    return s;
                  })(t);
              (I(S, "transform", `translate${v("X")}(${r + k}px)`),
                t !== r && a("sh"));
            }
          }
          function w(t, e) {
            var i = t - P(e),
              s = y();
            return t - b(s * (tt(te(i) / s) || 1)) * (e ? 1 : -1);
          }
          function T() {
            (_(B(), !0), n.cancel());
          }
          function A(t) {
            for (
              var e = i.Slides.get(), s = 0, n = 1 / 0, r = 0;
              r < e.length;
              r++
            ) {
              var o = e[r].index,
                a = te(M(o, !0) - t);
              if (a <= n) ((n = a), (s = o));
              else break;
            }
            return s;
          }
          function M(t, i) {
            var n,
              r,
              o,
              a = b(
                m(t - 1) -
                  ((n = t),
                  (r = s.focus),
                  "center" === r ? (f() - h(n, !0)) / 2 : +r * h(n) || 0),
              );
            return i
              ? ((o = a),
                s.trimSpace && e.is(eu) && (o = tn(o, 0, b(y(!0) - f()))),
                o)
              : a;
          }
          function B() {
            var t = v("left");
            return R(S)[t] - R(E)[t] + b(p(!1)) - k;
          }
          function P(t) {
            return M(t ? i.Controller.getEnd() : 0, !!s.trimSpace);
          }
          return {
            mount: function t() {
              ((n = i.Transition), o([tc, tv, ty, tf], x));
            },
            move: function t(e, i, s, r) {
              var o, d;
              (e !== i &&
                ((o = e > s),
                (d = b(w(B(), o))),
                o ? d >= 0 : d <= S[v("scrollWidth")] - R(E)[v("width")]) &&
                (T(), _(w(B(), e > s), !0)),
                l(4),
                a(tu, i, s, e),
                n.start(i, function () {
                  (l(3), a(tp, i, s, e), r && r());
                }));
            },
            jump: L,
            translate: _,
            shift: w,
            cancel: T,
            toIndex: A,
            toPosition: M,
            getPosition: B,
            getLimit: P,
            exceededLimit: function t(e, i) {
              i = u(i) ? B() : i;
              var s = !0 !== e && b(i) < b(P(!1)),
                n = !1 !== e && b(i) > b(P(!0));
              return s || n;
            },
            reposition: x,
          };
        },
        Controller: function t(e, i, n) {
          var r,
            o,
            a,
            l,
            d = tL(e),
            c = d.on,
            p = d.emit,
            m = i.Move,
            f = m.getPosition,
            y = m.getLimit,
            g = m.toPosition,
            v = i.Slides,
            b = v.isEnough,
            $ = v.getLength,
            S = n.omitEnd,
            E = e.is(ep),
            k = e.is(eu),
            C = s(A, !1),
            x = s(A, !0),
            L = n.start || 0,
            _ = L;
          function w() {
            ((o = $(!0)), (a = n.perMove), (l = n.perPage), (r = P()));
            var t = tn(L, 0, S ? r : o - 1);
            t !== L && ((L = t), m.reposition());
          }
          function T() {
            r !== P() && p("ei");
          }
          function A(t, e) {
            var i,
              s,
              n = a || (H() ? 1 : l),
              o = M(L + n * (t ? -1 : 1), L, !(a || H()));
            if (-1 === o && k) {
              if (((i = f()), !(1 > te(i - (s = y(!t)))))) return t ? 0 : r;
            }
            return e ? o : B(o);
          }
          function M(t, i, s) {
            if (b() || H()) {
              var d = (function t(i) {
                if (k && "move" === n.trimSpace && i !== L)
                  for (
                    var s = f();
                    s === g(i, !0) && ts(i, 0, e.length - 1, !n.rewind);
                  )
                    i < L ? --i : ++i;
                return i;
              })(t);
              (d !== t && ((i = t), (t = d), (s = !1)),
                t < 0 || t > r
                  ? (t =
                      !a && (ts(0, t, i, !0) || ts(r, i, t, !0))
                        ? I(q(t))
                        : E
                          ? s
                            ? t < 0
                              ? -(o % l || l)
                              : o
                            : t
                          : n.rewind
                            ? t < 0
                              ? r
                              : 0
                            : -1)
                  : s && t !== i && (t = I(q(i) + (t < i ? -1 : 1))));
            } else t = -1;
            return t;
          }
          function B(t) {
            return E ? (t + o) % o || 0 : t;
          }
          function P() {
            for (var t = o - (H() || (E && a) ? 1 : l); S && t-- > 0;)
              if (g(o - 1, !0) !== g(t, !0)) {
                t++;
                break;
              }
            return tn(t, 0, o - 1);
          }
          function I(t) {
            return tn(H() ? t : l * t, 0, r);
          }
          function q(t) {
            return H() ? Q(t, r) : Z((t >= r ? o - 1 : t) / l);
          }
          function D(t) {
            t !== L && ((_ = L), (L = t));
          }
          function H() {
            return !u(n.focus) || n.isNavigation;
          }
          function O() {
            return e.state.is([4, 5]) && !!n.waitForTransition;
          }
          return {
            mount: function t() {
              (w(), c([ty, tf, "ei"], w), c(tv, T));
            },
            go: function t(e, i, s) {
              if (!O()) {
                var n = (function t(e) {
                    var i = L;
                    if (h(e)) {
                      var s = e.match(/([+\-<>])(\d+)?/) || [],
                        n = s[1],
                        o = s[2];
                      "+" === n || "-" === n
                        ? (i = M(L + +("" + n + (+o || 1)), L))
                        : ">" === n
                          ? (i = o ? I(+o) : C(!0))
                          : "<" === n && (i = x(!0));
                    } else i = E ? e : tn(e, 0, r);
                    return i;
                  })(e),
                  o = B(n);
                o > -1 && (i || o !== L) && (D(o), m.move(n, o, _, s));
              }
            },
            scroll: function t(e, s, n, o) {
              i.Scroll.scroll(e, s, n, function () {
                var t = B(m.toIndex(f()));
                (D(S ? Q(t, r) : t), o && o());
              });
            },
            getNext: C,
            getPrev: x,
            getAdjacent: A,
            getEnd: P,
            setIndex: D,
            getIndex: function t(e) {
              return e ? _ : L;
            },
            toIndex: I,
            toPage: q,
            toDest: function t(e) {
              var i = m.toIndex(e);
              return k ? tn(i, 0, r) : i;
            },
            hasFocus: H,
            isBusy: O,
          };
        },
        Arrows: function t(e, i, n) {
          var r,
            o,
            a = tL(e),
            l = a.on,
            d = a.bind,
            c = a.emit,
            h = n.classes,
            u = n.i18n,
            p = i.Elements,
            m = i.Controller,
            f = p.arrows,
            y = p.track,
            g = f,
            v = p.prev,
            b = p.next,
            k = {};
          function C() {
            var t;
            ((t = n.arrows) &&
              !(v && b) &&
              ((g = f || P("div", h.arrows)),
              (v = T(!0)),
              (b = T(!1)),
              (r = !0),
              S(g, [v, b]),
              f || E(g, y)),
              v &&
                b &&
                (w(k, { prev: v, next: b }),
                q(g, t ? "" : "none"),
                $(g, (o = tY + "--" + n.direction)),
                t &&
                  (l([tc, tp, tf, t$, "ei"], A),
                  d(b, "click", s(_, ">")),
                  d(v, "click", s(_, "<")),
                  A(),
                  B([v, b], tD, y.id),
                  c("arrows:mounted", v, b))),
              l(ty, x));
          }
          function x() {
            (L(), C());
          }
          function L() {
            (a.destroy(),
              U(g, o),
              r ? (z(f ? [v, b] : g), (v = b = null)) : M([v, b], t0));
          }
          function _(t) {
            m.go(t, !0);
          }
          function T(t) {
            return N(
              '<button class="' +
                h.arrow +
                " " +
                (t ? h.prev : h.next) +
                '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' +
                (n.arrowPath ||
                  "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") +
                '" />',
            );
          }
          function A() {
            if (v && b) {
              var t = e.index,
                i = m.getPrev(),
                s = m.getNext(),
                n = i > -1 && t < i ? u.last : u.prev,
                r = s > -1 && t > s ? u.first : u.next;
              ((v.disabled = i < 0),
                (b.disabled = s < 0),
                B(v, tR, n),
                B(b, tR, r),
                c("arrows:updated", v, b, i, s));
            }
          }
          return { arrows: k, mount: C, destroy: L, update: A };
        },
        Autoplay: function t(e, i, s) {
          var n,
            r,
            o = tL(e),
            a = o.on,
            l = o.bind,
            d = o.emit,
            c = t_(s.interval, e.go.bind(e, ">"), function t(e) {
              var i = u.bar;
              (i && I(i, "width", 100 * e + "%"), d("autoplay:playing", e));
            }),
            h = c.isPaused,
            u = i.Elements,
            p = i.Elements,
            m = p.root,
            f = p.toggle,
            y = s.autoplay,
            g = "pause" === y;
          function v() {
            h() &&
              i.Slides.isEnough() &&
              (c.start(!s.resetProgress), (r = n = g = !1), E(), d(tk));
          }
          function $(t) {
            (void 0 === t && (t = !0),
              (g = !!t),
              E(),
              h() || (c.pause(), d(tC)));
          }
          function S() {
            g || (n || r ? $(!1) : v());
          }
          function E() {
            f && (b(f, ee, !g), B(f, tR, s.i18n[g ? "play" : "pause"]));
          }
          function k(t) {
            var e = i.Slides.getAt(t);
            c.set((e && +H(e.slide, ef)) || s.interval);
          }
          return {
            mount: function t() {
              y &&
                (s.pauseOnHover &&
                  l(m, "mouseenter mouseleave", function (t) {
                    ((n = "mouseenter" === t.type), S());
                  }),
                s.pauseOnFocus &&
                  l(m, "focusin focusout", function (t) {
                    ((r = "focusin" === t.type), S());
                  }),
                f &&
                  l(f, "click", function () {
                    g ? v() : $(!0);
                  }),
                a([tu, tb, tf], c.rewind),
                a(tu, k),
                f && B(f, tD, u.track.id),
                g || v(),
                E());
            },
            destroy: c.cancel,
            play: v,
            pause: $,
            isPaused: h,
          };
        },
        Cover: function t(e, i, n) {
          var r = tL(e).on;
          function o(t) {
            i.Slides.forEach(function (e) {
              var i = x(e.container || e.slide, "img");
              i && i.src && a(t, i, e);
            });
          }
          function a(t, e, i) {
            (i.style(
              "background",
              t ? 'center/cover no-repeat url("' + e.src + '")' : "",
              !0,
            ),
              q(e, t ? "none" : ""));
          }
          return {
            mount: function t() {
              n.cover && (r(tx, s(a, !0)), r([tc, ty, tf], s(o, !0)));
            },
            destroy: s(o, !1),
          };
        },
        Scroll: function t(e, i, n) {
          var r,
            o,
            a = tL(e),
            l = a.on,
            d = a.emit,
            c = e.state.set,
            h = i.Move,
            u = h.getPosition,
            p = h.getLimit,
            m = h.exceededLimit,
            f = h.translate,
            y = e.is(eu),
            g = 1;
          function v(t, e, n, a, l) {
            var p = u();
            if ((S(), n && (!y || !m()))) {
              var f = i.Layout.sliderSize(),
                v = tr(t) * f * Z(te(t) / f) || 0;
              t = h.toPosition(i.Controller.toDest(t % f)) + v;
            }
            var E,
              k,
              C = ((E = p), (k = t), 1 > te(E - k));
            ((g = 1),
              (e = C ? 0 : e || J(te(t - p) / 1.5, 800)),
              (o = a),
              (r = t_(e, b, s($, p, t, l), 1)),
              c(5),
              d(tb),
              r.start());
          }
          function b() {
            (c(3), o && o(), d(t$));
          }
          function $(t, e, i, s) {
            var r,
              a,
              l = u(),
              d =
                (t +
                  (e - t) *
                    ((r = s),
                    (a = n.easingFunc),
                    a ? a(r) : 1 - Math.pow(1 - r, 4)) -
                  l) *
                g;
            (f(l + d),
              y &&
                !i &&
                m() &&
                ((g *= 0.6), 10 > te(d) && v(p(m(!0)), 600, !1, o, !0)));
          }
          function S() {
            r && r.cancel();
          }
          function E() {
            r && !r.isPaused() && (S(), b());
          }
          return {
            mount: function t() {
              (l(tu, S), l([ty, tf], E));
            },
            destroy: S,
            scroll: v,
            cancel: E,
          };
        },
        Drag: function t(e, i, s) {
          var n,
            o,
            a,
            d,
            c,
            h,
            u,
            p,
            m = tL(e),
            f = m.on,
            y = m.emit,
            g = m.bind,
            v = m.unbind,
            b = e.state,
            $ = i.Move,
            S = i.Scroll,
            E = i.Controller,
            C = i.Elements.track,
            x = i.Media.reduce,
            L = i.Direction,
            _ = L.resolve,
            w = L.orient,
            T = $.getPosition,
            A = $.exceededLimit,
            M = !1;
          function B() {
            var t,
              e = s.drag;
            ((u = t = !e), (d = "free" === e));
          }
          function P(t) {
            if (((h = !1), !u)) {
              var e,
                i,
                n = V(t);
              ((e = t.target),
                (i = s.noDrag),
                k(e, "." + tQ + ", ." + t6) ||
                  (i && k(e, i)) ||
                  (!n && t.button) ||
                  (E.isBusy()
                    ? F(t, !0)
                    : ((p = n ? C : window),
                      (c = b.is([4, 5])),
                      (a = null),
                      g(p, ec, I, ey),
                      g(p, eh, q, ey),
                      $.cancel(),
                      S.cancel(),
                      H(t))));
            }
          }
          function I(t) {
            if ((b.is(6) || (b.set(6), y("drag")), t.cancelable)) {
              if (c) {
                $.translate(n + ((p = O(t)), p / (M && e.is(eu) ? 5 : 1)));
                var i,
                  r,
                  o,
                  a,
                  d,
                  u,
                  p,
                  m = R(t) > 200,
                  f = M !== (M = A());
                ((m || f) && H(t), (h = !0), y("dragging"), F(t));
              } else {
                ((i = t),
                  te(O(i)) > te(O(i, !0)) &&
                    ((c =
                      ((r = t),
                      (o = s.dragMinThreshold),
                      (a = l(o)),
                      (d = (a && o.mouse) || 0),
                      (u = (a ? o.touch : +o) || 10),
                      te(O(r)) > (V(r) ? u : d))),
                    F(t)));
              }
            }
          }
          function q(t) {
            var n, r, o, a, l;
            (b.is(6) && (b.set(3), y("dragged")),
              c &&
                ((a =
                  ((r = o =
                    (function t(i) {
                      if (e.is(ep) || !M) {
                        var s = R(i);
                        if (s && s < 200) return O(i) / s;
                      }
                      return 0;
                    })((n = t))),
                  T() +
                    tr(r) *
                      Q(
                        te(r) * (s.flickPower || 600),
                        d
                          ? 1 / 0
                          : i.Layout.listSize() * (s.flickMaxPages || 1),
                      ))),
                (l = s.rewind && s.rewindByDrag),
                x(!1),
                d
                  ? E.scroll(a, 0, s.snap)
                  : e.is(em)
                    ? E.go(0 > w(tr(o)) ? (l ? "<" : "-") : l ? ">" : "+")
                    : e.is(eu) && M && l
                      ? E.go(A(!0) ? ">" : "<")
                      : E.go(E.toDest(a), !0),
                x(!0),
                F(t)),
              v(p, ec, I),
              v(p, eh, q),
              (c = !1));
          }
          function D(t) {
            !u && h && F(t, !0);
          }
          function H(t) {
            ((a = o), (o = t), (n = T()));
          }
          function O(t, e) {
            return N(t, e) - N(z(t), e);
          }
          function R(t) {
            return X(t) - X(z(t));
          }
          function z(t) {
            return (o === t && a) || o;
          }
          function N(t, e) {
            return (V(t) ? t.changedTouches[0] : t)["page" + _(e ? "Y" : "X")];
          }
          function V(t) {
            return "undefined" != typeof TouchEvent && t instanceof TouchEvent;
          }
          function W() {
            return c;
          }
          function U(t) {
            u = t;
          }
          return {
            mount: function t() {
              (g(C, ec, r, ey),
                g(C, eh, r, ey),
                g(C, ed, P, ey),
                g(C, "click", D, { capture: !0 }),
                g(C, "dragstart", F),
                f([tc, ty], B));
            },
            disable: U,
            isDragging: W,
          };
        },
        Keyboard: function t(e, i, s) {
          var r,
            o,
            a = tL(e),
            l = a.on,
            d = a.bind,
            c = a.unbind,
            h = e.root,
            u = i.Direction.resolve;
          function p() {
            var t = s.keyboard;
            t && d((r = "global" === t ? window : h), eb, g);
          }
          function m() {
            c(r, eb);
          }
          function f(t) {
            o = t;
          }
          function y() {
            var t = o;
            ((o = !0),
              n(function () {
                o = t;
              }));
          }
          function g(t) {
            if (!o) {
              var i = ev(t);
              i === u(tw) ? e.go("<") : i === u(tT) && e.go(">");
            }
          }
          return {
            mount: function t() {
              (p(), l(ty, m), l(ty, p), l(tu, y));
            },
            destroy: m,
            disable: f,
          };
        },
        LazyLoad: function t(i, n, r) {
          var o = tL(i),
            a = o.on,
            l = o.off,
            d = o.bind,
            c = o.emit,
            h = "sequential" === r.lazyLoad,
            u = [tp, t$],
            p = [];
          function m() {
            (e(p),
              n.Slides.forEach(function (t) {
                W(t.slide, eE).forEach(function (e) {
                  var i = H(e, e$),
                    s = H(e, eS);
                  if (i !== e.src || s !== e.srcset) {
                    var n = r.classes.spinner,
                      o = e.parentElement,
                      a = x(o, "." + n) || P("span", n, o);
                    (p.push([e, t, a]), e.src || q(e, "none"));
                  }
                });
              }),
              h ? v() : (l(u), a(u, f), f()));
          }
          function f() {
            (p = p.filter(function (t) {
              var e = r.perPage * ((r.preloadPages || 1) + 1) - 1;
              return !t[1].isWithin(i.index, e) || y(t);
            })).length || l(u);
          }
          function y(t) {
            var e = t[0];
            ($(t[1].slide, er),
              d(e, "load error", s(g, t)),
              B(e, "src", H(e, e$)),
              B(e, "srcset", H(e, eS)),
              M(e, e$),
              M(e, eS));
          }
          function g(t, e) {
            var i = t[0],
              s = t[1];
            (U(s.slide, er),
              "error" !== e.type && (z(t[2]), q(i, ""), c(tx, i, s), c(tg)),
              h && v());
          }
          function v() {
            p.length && y(p.shift());
          }
          return {
            mount: function t() {
              r.lazyLoad && (m(), a(tf, m));
            },
            destroy: s(e, p),
            check: f,
          };
        },
        Pagination: function t(n, r, o) {
          var a,
            l,
            d = tL(n),
            c = d.on,
            h = d.emit,
            u = d.bind,
            p = r.Slides,
            m = r.Elements,
            f = r.Controller,
            y = f.hasFocus,
            g = f.getIndex,
            v = f.go,
            b = r.Direction.resolve,
            S = m.pagination,
            E = [];
          function k() {
            (C(), c([ty, tf, "ei"], k));
            var t = o.pagination;
            (S && q(S, t ? "" : "none"),
              t &&
                (c([tu, tb, t$], T),
                (function t() {
                  var e = n.length,
                    i = o.classes,
                    r = o.i18n,
                    d = o.perPage,
                    c = y() ? f.getEnd() + 1 : tt(e / d);
                  ((a = S || P("ul", i.pagination, m.track.parentElement)),
                    $(a, (l = t5 + "--" + _())),
                    B(a, tP, "tablist"),
                    B(a, tR, r.select),
                    B(a, tF, "ttb" === _() ? "vertical" : ""));
                  for (var h = 0; h < c; h++) {
                    var g = P("li", null, a),
                      v = P("button", { class: i.page, type: "button" }, g),
                      b = p.getIn(h).map(function (t) {
                        return t.slide.id;
                      }),
                      k = !y() && d > 1 ? r.pageX : r.slideX;
                    (u(v, "click", s(x, h)),
                      o.paginationKeyboard && u(v, "keydown", s(L, h)),
                      B(g, tP, "presentation"),
                      B(v, tP, "tab"),
                      B(v, tD, b.join(" ")),
                      B(v, tR, to(k, h + 1)),
                      B(v, tI, -1),
                      E.push({ li: g, button: v, page: h }));
                  }
                })(),
                T(),
                h("pagination:mounted", { list: a, items: E }, w(n.index))));
          }
          function C() {
            (a && (z(S ? i(a.children) : a), U(a, l), e(E), (a = null)),
              d.destroy());
          }
          function x(t) {
            v(">" + t, !0);
          }
          function L(t, e) {
            var i = E.length,
              s = ev(e),
              n = _(),
              r = -1;
            s === b(tT, !1, n)
              ? (r = ++t % i)
              : s === b(tw, !1, n)
                ? (r = (--t + i) % i)
                : "Home" === s
                  ? (r = 0)
                  : "End" === s && (r = i - 1);
            var o = E[r];
            o && (D(o.button), v(">" + r), F(e, !0));
          }
          function _() {
            return o.paginationDirection || o.direction;
          }
          function w(t) {
            return E[f.toPage(t)];
          }
          function T() {
            var t = w(g(!0)),
              e = w(g());
            if (t) {
              var i = t.button;
              (U(i, ee), M(i, tO), B(i, tI, -1));
            }
            if (e) {
              var s = e.button;
              ($(s, ee), B(s, tO, !0), B(s, tI, ""));
            }
            h("pagination:updated", { list: a, items: E }, t, e);
          }
          return { items: E, mount: k, destroy: C, getAt: w, update: T };
        },
        Sync: function t(i, n, r) {
          var o = r.isNavigation,
            a = r.slideFocus,
            l = [];
          function d() {
            var t, e;
            (i.splides.forEach(function (t) {
              t.isParent || (h(i, t.splide), h(t.splide, i));
            }),
              o &&
                ((t = tL(i)),
                (e = t.on),
                e(tm, m),
                e("sk", f),
                e([tc, ty], p),
                l.push(t),
                t.emit(tE, i.splides)));
          }
          function c() {
            (l.forEach(function (t) {
              t.destroy();
            }),
              e(l));
          }
          function h(t, e) {
            var i = tL(t);
            (i.on(tu, function (t, i, s) {
              e.go(e.is(ep) ? s : t);
            }),
              l.push(i));
          }
          function p() {
            B(n.Elements.list, tF, "ttb" === r.direction ? "vertical" : "");
          }
          function m(t) {
            i.go(t.index);
          }
          function f(t, e) {
            g(ek, ev(e)) && (m(t), F(e));
          }
          return {
            setup: s(n.Media.set, { slideFocus: u(a) ? o : a }, !0),
            mount: d,
            destroy: c,
            remount: function t() {
              (c(), d());
            },
          };
        },
        Wheel: function t(e, i, s) {
          var n = tL(e).bind,
            r = 0;
          function o(t) {
            if (t.cancelable) {
              var n,
                o = t.deltaY,
                a = o < 0,
                l = X(t),
                d = s.wheelMinThreshold || 0,
                c = s.wheelSleep || 0;
              (te(o) > d && l - r > c && (e.go(a ? "<" : ">"), (r = l)),
                (n = a),
                (!s.releaseWheel ||
                  e.state.is(4) ||
                  -1 !== i.Controller.getAdjacent(n)) &&
                  F(t));
            }
          }
          return {
            mount: function t() {
              s.wheel && n(i.Elements.track, "wheel", o, ey);
            },
          };
        },
        Live: function t(e, i, n) {
          var r = tL(e).on,
            o = i.Elements.track,
            a = n.live && !n.isNavigation,
            l = P("span", et),
            d = t_(90, s(c, !1));
          function c(t) {
            (B(o, t9, t), t ? (S(o, l), d.start()) : (z(l), d.cancel()));
          }
          function h(t) {
            a && B(o, tW, t ? "off" : "polite");
          }
          return {
            mount: function t() {
              a &&
                (h(!i.Autoplay.isPaused()),
                B(o, tU, !0),
                (l.textContent = "…"),
                r(tk, s(h, !0)),
                r(tC, s(h, !1)),
                r([tp, t$], s(c, !0)));
            },
            disable: h,
            destroy: function t() {
              (M(o, [tW, tU, t9]), z(l));
            },
          };
        },
      }),
      ex = {
        type: "slide",
        role: "region",
        speed: 400,
        perPage: 1,
        cloneStatus: !0,
        arrows: !0,
        pagination: !0,
        paginationKeyboard: !0,
        interval: 5e3,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        resetProgress: !0,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        drag: !0,
        direction: "ltr",
        trimSpace: !0,
        focusableNodes: "a, button, textarea, input, select, iframe",
        live: !0,
        classes: {
          slide: tX,
          clone: tG,
          arrows: tY,
          arrow: t6,
          prev: t7,
          next: tK,
          pagination: t5,
          page: tQ,
          spinner: t2 + "spinner",
        },
        i18n: {
          prev: "Previous slide",
          next: "Next slide",
          first: "Go to first slide",
          last: "Go to last slide",
          slideX: "Go to slide %s",
          pageX: "Go to page %s",
          play: "Start autoplay",
          pause: "Pause autoplay",
          carousel: "carousel",
          slide: "slide",
          select: "Select a slide to show",
          slideLabel: "%s of %s",
        },
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" },
      };
    function eL(t, e, i) {
      var s = e.Slides;
      function o() {
        s.forEach(function (t) {
          t.style("transform", "translateX(-" + 100 * t.index + "%)");
        });
      }
      return {
        mount: function e() {
          tL(t).on([tc, tf], o);
        },
        start: function t(e, r) {
          (s.style("transition", "opacity " + i.speed + "ms " + i.easing),
            n(r));
        },
        cancel: r,
      };
    }
    function e_(t, e, i) {
      var n,
        r = e.Move,
        o = e.Controller,
        a = e.Scroll,
        l = e.Elements.list,
        d = s(I, l, "transition");
      function c() {
        (d(""), a.cancel());
      }
      return {
        mount: function e() {
          tL(t).bind(l, "transitionend", function (t) {
            t.target === l && n && (c(), n());
          });
        },
        start: function e(s, l) {
          var c = r.toPosition(s, !0),
            h = r.getPosition(),
            u = (function e(s) {
              var n = i.rewindSpeed;
              if (t.is(eu) && n) {
                var r = o.getIndex(!0),
                  a = o.getEnd();
                if ((0 === r && s >= a) || (r >= a && 0 === s)) return n;
              }
              return i.speed;
            })(s);
          te(c - h) >= 1 && u >= 1
            ? i.useScroll
              ? a.scroll(c, u, !1, l)
              : (d("transform " + u + "ms " + i.easing),
                r.translate(c, !0),
                (n = l))
            : (r.jump(s), l());
        },
        cancel: c,
      };
    }
    var e8 = (function () {
      function t(e, i) {
        ((this.event = tL()),
          (this.Components = {}),
          (this.state = (function t(e) {
            var i = 1;
            function s(t) {
              i = t;
            }
            return {
              set: s,
              is: function t(e) {
                return g(f(e), i);
              },
            };
          })(1)),
          (this.splides = []),
          (this._o = {}),
          (this._E = {}));
        var s = h(e) ? V(document, e) : e;
        (K(s, s + " is invalid."),
          (this.root = s),
          (i = T(
            { label: H(s, tR) || "", labelledby: H(s, tz) || "" },
            ex,
            t.defaults,
            i || {},
          )));
        try {
          T(i, JSON.parse(H(s, Y)));
        } catch (n) {
          K(!1, "Invalid JSON");
        }
        this._o = Object.create(T({}, i));
      }
      var s = t.prototype;
      return (
        (s.mount = function t(e, i) {
          var s = this,
            n = this.state,
            r = this.Components;
          (K(n.is([1, 7]), "Already mounted!"),
            n.set(1),
            (this._C = r),
            (this._T = i || this._T || (this.is(em) ? eL : e_)),
            (this._E = e || this._E));
          var o = w({}, eC, this._E, { Transition: this._T });
          return (
            _(o, function (t, e) {
              var i = t(s, r, s._o);
              ((r[e] = i), i.setup && i.setup());
            }),
            _(r, function (t) {
              t.mount && t.mount();
            }),
            this.emit(tc),
            $(this.root, "is-initialized"),
            n.set(3),
            this.emit(th),
            this
          );
        }),
        (s.sync = function t(e) {
          return (
            this.splides.push({ splide: e }),
            e.splides.push({ splide: this, isParent: !0 }),
            this.state.is(3) &&
              (this._C.Sync.remount(), e.Components.Sync.remount()),
            this
          );
        }),
        (s.go = function t(e) {
          return (this._C.Controller.go(e), this);
        }),
        (s.on = function t(e, i) {
          return (this.event.on(e, i), this);
        }),
        (s.off = function t(e) {
          return (this.event.off(e), this);
        }),
        (s.emit = function t(e) {
          var s;
          return (
            (s = this.event).emit.apply(s, [e].concat(i(arguments, 1))),
            this
          );
        }),
        (s.add = function t(e, i) {
          return (this._C.Slides.add(e, i), this);
        }),
        (s.remove = function t(e) {
          return (this._C.Slides.remove(e), this);
        }),
        (s.is = function t(e) {
          return this._o.type === e;
        }),
        (s.refresh = function t() {
          return (this.emit(tf), this);
        }),
        (s.destroy = function t(i) {
          void 0 === i && (i = !0);
          var s = this.event,
            n = this.state;
          return (
            n.is(1)
              ? tL(this).on(th, this.destroy.bind(this, i))
              : (_(
                  this._C,
                  function (t) {
                    t.destroy && t.destroy(i);
                  },
                  !0,
                ),
                s.emit(tS),
                s.destroy(),
                i && e(this.splides),
                n.set(7)),
            this
          );
        }),
        _createClass(t, [
          {
            key: "options",
            get: function t() {
              return this._o;
            },
            set: function t(e) {
              this._C.Media.set(e, !0, !0);
            },
          },
          {
            key: "length",
            get: function t() {
              return this._C.Slides.getLength(!0);
            },
          },
          {
            key: "index",
            get: function t() {
              return this._C.Controller.getIndex();
            },
          },
        ]),
        t
      );
    })();
    return (
      (e8.defaults = {}),
      (e8.STATES = {
        CREATED: 1,
        MOUNTED: 2,
        IDLE: 3,
        MOVING: 4,
        SCROLLING: 5,
        DRAGGING: 6,
        DESTROYED: 7,
      }),
      e8
    );
  }));
class SplideComponent extends HTMLElement {
  constructor() {
    (super(),
      (this.sliderContainer = this.querySelector(".splide")),
      document.addEventListener("shopify:section:load", (t) => {
        this.initSlider();
      }));
  }
  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    ((this.type = this.dataset.type || "slide"),
      (this.typeMobile = this.dataset.typeMobile || this.type),
      (this.direction = this.dataset.direction || defaultDirection),
      (this.rewind = "fade" === this.type),
      (this.autoplay = "true" === this.dataset.autoplay),
      (this.autoplaySpeed =
        this.dataset.autoplaySpeed &&
        !isNaN(parseInt(this.dataset.autoplaySpeed))
          ? 1e3 * parseInt(this.dataset.autoplaySpeed)
          : 5e3),
      (this.drag =
        "false" !== this.dataset.drag &&
        ("free" !== this.dataset.drag || "free")),
      (this.focus = this.dataset.focus || 0),
      (this.trimSpace = "false" !== this.dataset.trimSpace),
      (this.arrows = "false" !== this.dataset.arrows),
      (this.arrowsColor = this.dataset.arrowsColor
        ? ` color-${this.dataset.arrowsColor}`
        : ""),
      (this.pagination = "false" !== this.dataset.pagination),
      (this.omitEnd = "false" !== this.dataset.omitEnd),
      (this.dotsColor = this.dataset.dotsColor
        ? ` color-${this.dataset.dotsColor} dots-custom-color`
        : ""),
      (this.slidesDesktop =
        this.dataset.slidesDesktop &&
        !isNaN(parseInt(this.dataset.slidesDesktop))
          ? parseInt(this.dataset.slidesDesktop)
          : 3),
      (this.autoWidth = "true" === this.dataset.autoWidth),
      (this.slidesMobile =
        this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile))
          ? parseInt(this.dataset.slidesMobile)
          : 1),
      (this.perMoveDesktop =
        this.dataset.perMoveDesktop &&
        !isNaN(parseInt(this.dataset.perMoveDesktop))
          ? parseInt(this.dataset.perMoveDesktop)
          : 1),
      (this.perMoveMobile =
        this.dataset.perMoveMobile &&
        !isNaN(parseInt(this.dataset.perMoveMobile))
          ? parseInt(this.dataset.perMoveMobile)
          : 1),
      (this.gapDesktop = this.dataset.gapDesktop
        ? parseInt(this.dataset.gapDesktop)
        : 30),
      (this.gapMobile = this.dataset.gapMobile
        ? parseInt(this.dataset.gapMobile)
        : 15),
      (this.paddingCalcDesktop = "true" === this.dataset.paddingCalcDesktop),
      (this.rightPaddingDesktop =
        parseInt(this.dataset.sidePaddingDesktop) || 0),
      (this.leftPaddingDesktop = this.dataset.paddingCalcDesktop
        ? 0
        : this.rightPaddingDesktop),
      (this.paddingCalcMobile = "true" === this.dataset.paddingCalcMobile),
      (this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0),
      (this.leftPaddingMobile = this.paddingCalcMobile
        ? 0
        : this.rightPaddingMobile),
      (this.destroyDesktop = "true" === this.dataset.destroyDesktop),
      (this.destroyMobile = "true" === this.dataset.destroyMobile),
      (this.config = {
        type: this.type,
        direction: this.direction,
        rewind: this.rewind,
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        drag: this.drag,
        focus: this.focus,
        trimSpace: this.trimSpace,
        arrows: this.arrows,
        pagination: this.pagination,
        omitEnd: this.omitEnd,
        perPage: this.slidesDesktop,
        perMove: this.perMoveDesktop,
        autoWidth: this.autoWidth,
        gap: this.gapDesktop,
        paddingCalc: this.paddingCalcDesktop,
        padding: {
          left: this.leftPaddingDesktop,
          right: this.rightPaddingDesktop,
        },
        destroy: this.destroyDesktop,
        classes: {
          arrow: `splide__arrow${this.arrowsColor}`,
          page: `splide__pagination__page${this.dotsColor}`,
        },
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        breakpoints: {
          749: {
            omitEnd: this.omitEnd,
            type: this.typeMobile,
            perPage: this.slidesMobile,
            perMove: this.perMoveMobile,
            gap: this.gapMobile,
            paddingCalc: this.paddingCalcMobile,
            padding: {
              left: this.leftPaddingMobile,
              right: this.rightPaddingMobile,
            },
            destroy: this.destroyMobile,
          },
        },
      }));
    let t = new Splide(this.sliderContainer, this.config);
    (t.on("mounted", () => {
      let e = t.index,
        i = t.Components.Elements.slides[e];
      if (i) {
        let s = i.querySelector("img");
        s
          ? s.complete
            ? (i.classList.add("is-instant-active"),
              this.setActiveSlideHeight(i))
            : s.addEventListener("load", () => {
                (i.classList.add("is-instant-active"),
                  this.setActiveSlideHeight(i));
              })
          : (i.classList.add("is-instant-active"),
            this.setActiveSlideHeight(i));
      }
      let n = debounce(() => {
        let e = t.Components.Elements.slides[t.index];
        this.setActiveSlideHeight(e);
      }, 200);
      window.addEventListener("resize", n);
    }),
      t.on("move", (e) => {
        let i = t.index,
          s = t.Components.Elements.slides;
        if (s) {
          let n = s[i];
          n &&
            (s.forEach((t) => t.classList.remove("is-instant-active")),
            n.classList.add("is-instant-active"),
            this.setActiveSlideHeight(n));
        }
      }),
      "true" === this.dataset.pauseVideos &&
        t.on("hidden", (t) => {
          let e = t.slide.querySelector("internal-video");
          if (e) {
            let i = e.dataset.actionOnInactive;
            "pause" === i
              ? (e.video.pause(), e.classList.remove("internal-video--playing"))
              : "mute" === i &&
                ((e.video.muted = !0),
                e.classList.add("internal-video--muted"));
          }
        }),
      t.mount());
  }
  setActiveSlideHeight(t) {
    if (t) {
      let e = t.offsetHeight;
      this.style.setProperty("--active-slide-height", `${e}px`);
    }
  }
}
customElements.define("splide-component", SplideComponent);
